import { useContext, useEffect } from "react";
import SuperAdminAuthContext from "../../context/superadmin/SuperAdminAuthContext";

const SuperAdminLogout = () => {
  const { logoutSuperAdmin } = useContext(SuperAdminAuthContext);

  useEffect(() => {
    logoutSuperAdmin();
  }, [logoutSuperAdmin]);

  return <></>;
};

export default SuperAdminLogout;
